import { authController } from "@reedexpo/authorization-component-ui";
import { GetTokenOptions } from "./types";
import NetworkHelper from "../network/helpers/network/helper/NetworkHelper";
import store from "../../redux/store";
import { setOffline } from "../../redux/metadata/slice/metadataSlice";

const clientIdCookieName = "ClientId";

const getCookies = () => {
  const cookies: { [key: string]: string } = {};
  document.cookie.split("; ").forEach(cookie => {
    const [name, value] = cookie.split("=");
    if (name && value) {
      cookies[name] = decodeURIComponent(value);
    }
  });
  return cookies;
};

const RELOAD_GUARD_KEY = "auth_reload_attempted";

const getToken = async (options: GetTokenOptions = { skipRefetch: false }): Promise<string> => {
  try {
    const token = await authController.getToken();
    // Successful token retrieval clears the reload guard
    sessionStorage.removeItem(RELOAD_GUARD_KEY);
    return token;
  } catch (e) {
    const isNetworkAvailable = await NetworkHelper.isConnected();
    store.dispatch(setOffline(!isNetworkAvailable));
    if (isNetworkAvailable && !options.skipRefetch) {
      // Prevent infinite reload loop by only reloading once per tab session
      if (!sessionStorage.getItem(RELOAD_GUARD_KEY)) {
        sessionStorage.setItem(RELOAD_GUARD_KEY, "1");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        console.warn("Auth token retrieval failed again; suppressing further reload attempts.");
      }
    }
    return "";
  }
};

const getClientId = () => getCookies()[clientIdCookieName] || null;

const authorizationStore = {
  getToken,
  getClientId
};

export default authorizationStore;
